export default __webpack_public_path__ + "turbine.png?2d749ee82af996c27d8546b6de582ddc";